import React from "react"

function Desk({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="12.5" y="8.5" width="11" height="7" rx="0.5" stroke="#003E4C" strokeWidth="0.75" />
      <path d="M18 15.5V18" stroke="#003E4C" strokeWidth="0.75" />
      <path d="M8 18H28" stroke="#003E4C" strokeWidth="0.75" />
      <path d="M10 18V28" stroke="#003E4C" strokeWidth="0.75" />
      <path d="M20.5 18V28" stroke="#003E4C" strokeWidth="0.75" />
      <rect x="21" y="18.5" width="6.5" height="9" stroke="#003E4C" strokeWidth="0.75" />
      <path d="M21 23H27.5" stroke="#003E4C" strokeWidth="0.75" />
      <path d="M23.5 20.75H25" stroke="#003E4C" strokeWidth="0.75" />
      <path d="M23.5 25.25H25" stroke="#003E4C" strokeWidth="0.75" />
    </svg>
  )
}
export default Desk
